import { render } from "./HistoryNoteCard.vue?vue&type=template&id=64ac954f&scoped=true"
import script from "./HistoryNoteCard.vue?vue&type=script&lang=js"
export * from "./HistoryNoteCard.vue?vue&type=script&lang=js"

import "./HistoryNoteCard.vue?vue&type=style&index=0&id=64ac954f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ac954f"]])

export default __exports__